export const LANGUAGES = `${process.env.REACT_APP_LANGUAGES || 'ru'}`
  .split(',')
  .map(lang => lang.trim())
